export default __webpack_public_path__ + "static/security_b.34c645fbfa9c077645aefdb84590850f.svg";